import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { TipoAssistenza } from '@app/shared/models/assistenza';
import { UtilityService } from '@app/shared/services/utility.service';

@Component({
  selector: 'ser-tipo-assistenza-select',
  templateUrl: './tipo-assistenza-select.component.html',
  styleUrl: './tipo-assistenza-select.component.scss'
})
export class TipoAssistenzaSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() label: string = "assistenze.fields.tipo";
  @Input() readonly: boolean = false;
  @Input() multiple: boolean = false;

  tipi: IS1InputSelectItem[];

  constructor(private utils: UtilityService) {
    this.tipi = this.utils.getInputSelectFromEnum(TipoAssistenza);
  }

}
